import HTTPService from './services/HTTPService.es6';
import { addClass, getParent, removeClass } from './domHelpers';
import { getFormValues } from './form.es6';
import Ga from './ga';
import Navigation from './navigation';
import { getThorViewEventProps, thorPushEvent } from './thor';

function successCallback(response, innerCallback) {
    const newCartridge = response.data.trim();
    if (window.matchMedia('(min-width: 1260px)').matches) {
        const cartridgeContainer = document.querySelector('[data-nav-account-menu]');
        cartridgeContainer.innerHTML = newCartridge;
    } else {
        const cartridgeContainer = document.querySelector('[data-nav-account-menu-mobile]');
        cartridgeContainer.innerHTML = newCartridge;
    }
    innerCallback();
}

function failCallback(domNode, formType, e) {
    if (e.response && e.response.status === 400) {
        const error = e.response.data;
        if (error) {
            Object.keys(error).forEach(key => {
                const controlSelector = `[data-${formType}-${key}]`;
                const fieldControl = domNode.querySelector(controlSelector);
                const field = getParent(fieldControl, '[data-control-group]');
                if (!field) {
                    global.console.warn(`Unable to find parent of '${controlSelector}'`);
                    return;
                }
                const errorLabelContainer = document.createElement('div');
                const errorMsg = document.createTextNode(error[key][0]);
                addClass(field, 'field--invalid');
                addClass(errorLabelContainer, 'field__errors');
                errorLabelContainer.appendChild(errorMsg);
                field.querySelector('.field__control-wrapper').appendChild(errorLabelContainer);
            });
        }
    }
}

export function handleProSelection() {
    const container = document.querySelector('[data-auth-section]');
    const optinContainer = document.querySelector('[data-signup-optin_partners-container]');
    container
        .querySelector('[data-signup-is_pro]')
        .addEventListener('change', function handleTogglePro() {
            const profileContainer = container.querySelector('[data-signup-profile-container]');
            if (this.checked) {
                removeClass(profileContainer, 'hide');
                addClass(optinContainer, 'hide');
            } else {
                addClass(profileContainer, 'hide');
                removeClass(optinContainer, 'hide');
            }
        });

    container
        .querySelector('[data-signup-profile]')
        .addEventListener('change', function handleRealtorPosition() {
            const realtorPositionContainer = container.querySelector(
                '[data-signup-profile_realtor_position-container]',
            );
            if (this.value === 'USER_PROFILE.REALTOR') {
                removeClass(realtorPositionContainer, 'hide');
            } else {
                addClass(realtorPositionContainer, 'hide');
            }
        });
}

function handleSignUp(popup, callback, gaLabel, gaCategory) {
    const inputs = document.querySelector('[data-signup-form]').querySelectorAll('input');
    let formStarted = false;
    for (let n = 0; n < inputs.length; n++) {
        // eslint-disable-next-line no-loop-func
        inputs[n].addEventListener('click', () => {
            if (!formStarted) {
                Ga.send({
                    hitType: 'event',
                    eventCategory: gaCategory,
                    eventAction: 'signup_form:started',
                    eventLabel: gaLabel,
                });
            }
            formStarted = true;
        });
    }

    document.querySelector('[data-signup-submit]').addEventListener('click', eventCreateAccount => {
        eventCreateAccount.preventDefault();

        Ga.send({
            hitType: 'event',
            eventCategory: gaCategory,
            eventAction: 'signup_form:submit:attempt',
            eventLabel: gaLabel,
        });

        const form = document.querySelector('[data-signup-form]');
        const errors = form.querySelectorAll('.field__errors');
        const errorsField = form.querySelectorAll('.field--invalid');

        for (let n = 0; n < errors.length; n++) {
            if (errors[n].parentNode) {
                errors[n].parentNode.removeChild(errors[n]);
            }
        }
        for (let n = 0; n < errorsField.length; n++) {
            removeClass(errorsField[n], 'field--invalid');
        }

        HTTPService.post(form.getAttribute('action'), getFormValues(form))
            .then(() => {
                window.MA_USER.authenticated = true;

                thorPushEvent('sign_up', { method: 'regular' });
                Ga.send({
                    hitType: 'event',
                    eventCategory: gaCategory,
                    eventAction: 'signup_form:submit:success',
                    eventLabel: gaLabel,
                });
                HTTPService.get('/render_auth').then(response => {
                    popup.close();
                    successCallback(response, callback);
                });
            })
            .catch(e => {
                thorPushEvent('sign_up_error', { method: 'regular' });
                failCallback(form, 'signup', e);
            });
    });
}

function handleSignIn(popup, callback, gaLabel, gaCategory) {
    const inputs = document.querySelector('[data-signin-form]').querySelectorAll('input');
    let formStarted = false;
    for (let n = 0; n < inputs.length; n++) {
        // eslint-disable-next-line no-loop-func
        inputs[n].addEventListener('click', () => {
            if (!formStarted) {
                Ga.send({
                    hitType: 'event',
                    eventCategory: gaCategory,
                    eventAction: 'signin_form:started',
                    eventLabel: gaLabel,
                });
            }
            formStarted = true;
        });
    }

    document.querySelector('[data-signin-submit]').addEventListener('click', eventConnexion => {
        eventConnexion.preventDefault();

        Ga.send({
            hitType: 'event',
            eventCategory: gaCategory,
            eventAction: 'signin_form:submit:attempt',
            eventLabel: gaLabel,
        });

        const form = document.querySelector('[data-signin-form]');
        const errors = form.querySelectorAll('.field__errors');
        const errorsFields = form.querySelectorAll('.field--invalid');

        for (let n = 0; n < errors.length; n++) {
            if (errors[n].parentNode) {
                errors[n].parentNode.removeChild(errors[n]);
            }
        }
        for (let n = 0; n < errorsFields.length; n++) {
            removeClass(errorsFields[n], 'field--invalid');
        }

        HTTPService.post(form.getAttribute('action'), getFormValues(form))
            .then(() => {
                window.MA_USER.authenticated = true;

                thorPushEvent('login', { method: 'regular' });
                Ga.send({
                    hitType: 'event',
                    eventCategory: gaCategory,
                    eventAction: 'signin_form:submit:success',
                    eventLabel: gaLabel,
                });

                HTTPService.get('/render_auth').then(response => {
                    popup.close();
                    successCallback(response, callback);
                });
            })
            .catch(e => {
                thorPushEvent('login_error', { method: 'regular' });
                failCallback(form, 'signin', e);
            });
    });
}

function handleTabsGA(parentNode, gaLabel, gaCategory) {
    parentNode.querySelector('a[href="#signin"]').addEventListener('click', () => {
        thorPushEvent('page_view', getThorViewEventProps('account', `account_login`));
        Ga.send({
            hitType: 'event',
            eventCategory: gaCategory,
            eventAction: 'signin_form:landed',
            eventLabel: gaLabel,
        });
    });

    parentNode.querySelector('a[href="#signup"]').addEventListener('click', () => {
        thorPushEvent('page_view', getThorViewEventProps('account', `account_create`));
        Ga.send({
            hitType: 'event',
            eventCategory: gaCategory,
            eventAction: 'signup_form:landed',
            eventLabel: gaLabel,
        });
    });
}

function toggleLegalText() {
    $('#legal-text-toggle').on('click', () => {
        $('#legal-text-description').toggle();
    });
}

export function openAuthPopin(callback, gaLabel, gaCategory) {
    $.magnificPopup.open(
        {
            fixedContentPos: 'fixed',
            items: {
                src: '[data-follow-connexion]',
            },
            callbacks: {
                open() {
                    const tabsNode = document
                        .querySelector('[data-follow-connexion]')
                        .querySelector('[data-tabs-nav]');
                    Navigation.handleTabsNavNative(tabsNode, undefined, 'nav-tabs__item--active');
                    thorPushEvent('page_view', getThorViewEventProps('account', `account_login`));
                    Ga.send({
                        hitType: 'event',
                        eventCategory: gaCategory,
                        eventAction: 'signin_form:landed',
                        eventLabel: gaLabel,
                    });

                    handleTabsGA(
                        document.querySelector('[data-follow-connexion]'),
                        gaLabel,
                        gaCategory,
                    );
                    toggleLegalText();
                    handleProSelection();
                    handleSignUp(this, callback, gaLabel, gaCategory);
                    handleSignIn(this, callback, gaLabel, gaCategory);
                },
                close() {
                    Navigation.enablePageScroll();
                    const authNode = document.querySelector('[data-auth-section]');
                    const newNode = authNode.cloneNode(true);
                    authNode.parentElement.replaceChild(newNode, authNode);
                },
            },
        },
        0,
    );
}
